module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon1.6453abe10a5120def878195683aa6a4d.png";